import React from 'react';
import PropTypes from 'prop-types';
import QueryManager from './Query';
import gql from 'graphql-tag';
import { get, orderBy, filter, includes } from 'lodash';
export const GET_PICKERS = gql`
query getUsersFeed($size: Int, $page: Int, $sort: [SortInput], $filters: [FilterInput], $fields: [String], $or: OrInput) {
  getUsersFeed(size: $size, page: $page, sort: $sort, filters: $filters, fields: $fields, or: $or) {
    count
    page
    results {
      ... on Picker {
        id
        firstName
        lastName
        email
        phone
        status
        document
        status
        createdAt
        updatedAt
        lastConnection
        typeUser
        switchAutoSala
        profiles
        statusUser
        company
        salesChannels {
          value: id
          id
          isActive
        }
      }
    }
  }
}`;

const onFetchMoreResponse = (previousResult, { fetchMoreResult }) => {
    const response = {
        ...fetchMoreResult,
        customers: {
            ...fetchMoreResult.customers,
            count: fetchMoreResult.customers.count,
            cursor: fetchMoreResult.customers.cursor,
            results: [
                ...previousResult.customers.results,
                ...fetchMoreResult.customers.results
            ],
            __typename: previousResult.customers.__typename
        }
    };
    return response;
};

export const onPickerSearchAttempt = (client, variables) => {
    return client.query({ query: GET_PICKERS, variables: {}, fetchPolicy: 'network-only' })
        .then(({ data, ...response }) => ({
            data: get(data, 'getUsersFeed.results', []),
            count: get(data, 'getUsersFeed.count'),
            ...response
        }));
};

const Pickers = ({ children, salesChannelId, insideModal, ...props }) => {
    const { filters, ...variables } = get(props, 'variables', {});
    const filterSet = [
        { field: 'groups', type: 'object', value: [sessionStorage.getItem('SHOPPERS_PROFILE_ID')] },
        ...filters
    ];

    const fields = ['name', 'lastName', 'email', 'status', 'id'];

    // const fields = insideModal
    //   ? ['name', 'lastName', 'email', 'status', 'id']
    //   : [
    //     'name',
    //     'lastName',
    //     'email',
    //     'status',
    //     'id',
    //     'phone',
    //     'status',
    //     'rut',
    //     'statusUser',
    //     'company',
    //     'salesChannels',
    //     'switchAutoSala',
    //     'groups',
    //     'typeUser',
    //     'lastConnection',
    //     'updatedAt',
    //     'createdAt'
    //   ];

    return (
        <QueryManager {...props} query={GET_PICKERS} variables={{ ...variables, filters: filterSet, fields }} fetchPolicy='no-cache'>
            {({ data, loading, fetchMore, refetch }) => {
                const wantedStates = ['1', '2', '3', '4', 'null'];
                const users = filter(get(data, 'getUsersFeed.results', []), ({ status }) => {
                    return includes(wantedStates, status);
                });

                return children({
                    data: orderBy(users, [picker => picker.firstName.toLowerCase()]),
                    count: get(data, 'getUsersFeed.count'),
                    refetch,
                    loading
                });
            }}
        </QueryManager>
    );
};

Pickers.propTypes = {
    children: PropTypes.any,
    variables: PropTypes.object,
    salesChannelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    insideModal: PropTypes.bool
};

export default Pickers;
